module.exports = __webpack_public_path__ + "static/media/b2.48c829ad.jpg";